var _rect, _rect2, _path, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItemLayoutLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 58,
    viewBox: "0 0 118 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 58,
    rx: 5,
    fill: "#EAEAEA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 15.5,
    width: 49,
    height: 4,
    rx: 1.5,
    fill: "#B4B3B3",
    stroke: "#939393"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.364 12.2529V13.7129H102.612V12.2529H103.364ZM103.271 20.2266V21.5352H102.524V20.2266H103.271ZM104.009 18.6494C104.009 18.4606 103.97 18.2962 103.892 18.1562C103.817 18.013 103.693 17.8844 103.521 17.7705C103.348 17.6533 103.117 17.5443 102.827 17.4434C102.41 17.2969 102.046 17.1325 101.733 16.9502C101.424 16.7646 101.183 16.5368 101.011 16.2666C100.841 15.9932 100.757 15.653 100.757 15.2461C100.757 14.8457 100.848 14.499 101.03 14.2061C101.216 13.9131 101.473 13.6868 101.802 13.5273C102.131 13.3678 102.515 13.2881 102.954 13.2881C103.293 13.2881 103.597 13.3385 103.867 13.4395C104.141 13.5404 104.373 13.6885 104.565 13.8838C104.757 14.0791 104.904 14.32 105.005 14.6064C105.109 14.8896 105.161 15.2152 105.161 15.583H103.989C103.989 15.3747 103.965 15.1891 103.916 15.0264C103.87 14.8604 103.802 14.7204 103.711 14.6064C103.62 14.4893 103.509 14.3997 103.379 14.3379C103.252 14.276 103.107 14.2451 102.944 14.2451C102.713 14.2451 102.523 14.2891 102.373 14.377C102.223 14.4616 102.113 14.5788 102.041 14.7285C101.973 14.8783 101.938 15.0492 101.938 15.2412C101.938 15.4268 101.974 15.5895 102.046 15.7295C102.118 15.8695 102.24 15.9964 102.412 16.1104C102.588 16.221 102.829 16.3333 103.135 16.4473C103.555 16.597 103.918 16.7646 104.224 16.9502C104.533 17.1325 104.771 17.3587 104.937 17.6289C105.106 17.8958 105.19 18.2327 105.19 18.6396C105.19 19.0596 105.093 19.416 104.897 19.709C104.705 20.002 104.435 20.2249 104.087 20.3779C103.742 20.5277 103.34 20.6025 102.881 20.6025C102.591 20.6025 102.303 20.5651 102.017 20.4902C101.733 20.4121 101.476 20.2852 101.245 20.1094C101.014 19.9336 100.83 19.7008 100.693 19.4111C100.557 19.1182 100.488 18.7601 100.488 18.3369H101.67C101.67 18.5908 101.704 18.8024 101.772 18.9717C101.841 19.141 101.934 19.2744 102.051 19.3721C102.168 19.4697 102.298 19.5397 102.441 19.582C102.588 19.6243 102.734 19.6455 102.881 19.6455C103.125 19.6455 103.33 19.6048 103.496 19.5234C103.665 19.4388 103.792 19.3216 103.877 19.1719C103.965 19.0189 104.009 18.8447 104.009 18.6494Z",
    fill: "#3A3A3A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 26,
    width: 77,
    height: 4,
    rx: 1.5,
    fill: "#D3D3D3",
    stroke: "#FAFAFA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 36,
    width: 63,
    height: 4,
    rx: 1.5,
    fill: "#D3D3D3",
    stroke: "#FAFAFA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 117,
    height: 57,
    rx: 4.5,
    stroke: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemLayoutLeft);
export default __webpack_public_path__ + "static/media/ItemLayoutLeft.9468e929fd40a8542b5b6fb526638496.svg";
export { ForwardRef as ReactComponent };